export default "__VITE_ASSET__DTKupy5e__"